import { EMPTY_LIST } from '../../../../../../constants/common'
import i18n from '../../../../../../i18n'
import {
  BUILDING_REQUIRED_AUDIENCE,
  NEWSBOARD_POST_AUDIENCE_TO_NOT_SIGNED_UP_DWELLERS,
  NEWSBOARD_POST_AUDIENCE_TO_NOT_SIGNED_UP_LANDLORDS,
  NEWSBOARD_POST_AUDIENCE_TO_SIGNED_UP_DWELLERS,
  NEWSBOARD_POST_AUDIENCE_TO_SIGNED_UP_LANDLORDS,
} from '../../../../Newsboard.constants'
import {
  ALL_BUILDING_GROUPS_COUNT,
  ALL_BUILDINGS_COUNT,
  ALL_BUILDINGS_OPTION,
} from '../../../NewsboardPostForm.constants'
import {
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING,
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING_GROUP,
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_NON_REGISTERED_USERS,
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_NON_REGISTERED_USERS_CHECKBOX,
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_RADIO_BUILDINGS,
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_REGISTERED_USERS,
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_REGISTERED_USERS_CHECKBOX,
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_TV_SCREENS,
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_USER_INFO_STATUS,
  NON_REGISTERED_USERS_OPTIONS,
  RecipientAudienceOptionValue,
  REGISTERED_USERS_OPTIONS,
  USERS_ALL_VALUE,
} from '../RecipientsField.constants'

import {
  AUDIENCE,
  NON_REGISTERED_USERS,
  REGISTERED_USERS,
  TAG_TRANSLATION_KEYS,
} from './CustomizeRecipientAudienceField.constants'

function parseAudience(values) {
  return AUDIENCE.filter(item => values[item])
}

function isAllUsersValue(value) {
  return value === USERS_ALL_VALUE
}

function parseRegisteredUsersAudience(values) {
  if (
    values[NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_REGISTERED_USERS_CHECKBOX]
  ) {
    const value =
      values[NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_REGISTERED_USERS].value

    return isAllUsersValue(value)
      ? [
          NEWSBOARD_POST_AUDIENCE_TO_SIGNED_UP_LANDLORDS,
          NEWSBOARD_POST_AUDIENCE_TO_SIGNED_UP_DWELLERS,
        ]
      : [value]
  }

  return EMPTY_LIST
}

function parseNonRegisteredUsersAudience(values) {
  if (
    values[
      NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_NON_REGISTERED_USERS_CHECKBOX
    ]
  ) {
    const value =
      values[NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_NON_REGISTERED_USERS]
        .value

    return isAllUsersValue(value)
      ? [
          NEWSBOARD_POST_AUDIENCE_TO_NOT_SIGNED_UP_LANDLORDS,
          NEWSBOARD_POST_AUDIENCE_TO_NOT_SIGNED_UP_DWELLERS,
        ]
      : [value]
  }

  return EMPTY_LIST
}

function parseBuildings(values) {
  if (
    values[NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_RADIO_BUILDINGS] !==
    RecipientAudienceOptionValue.Building
  ) {
    return {}
  }

  if (values[NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING].length > 0) {
    return {
      [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING]: values[
        NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING
      ].map(item => {
        return item.value
      }),
    }
  }

  return {}
}

function parseBuildingGroups(values) {
  if (
    values[NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_RADIO_BUILDINGS] !==
    RecipientAudienceOptionValue.BuildingGroups
  ) {
    return {}
  }

  if (
    values[NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING_GROUP].length > 0
  ) {
    return {
      [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING_GROUP]: values[
        NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING_GROUP
      ].map(item => {
        return item.value
      }),
    }
  }

  return {}
}

function toMultiValueList(values) {
  if (values?.length > 0) {
    return values.map(item => {
      return { label: i18n.t(TAG_TRANSLATION_KEYS[item]), value: item }
    })
  }

  return EMPTY_LIST
}

function isBuildingOrBuildingGroupTagValue(value) {
  if (value === ALL_BUILDINGS_OPTION) {
    return true
  }

  return Number.isFinite(value)
}

function excludeBuildingOrBuildingGroup(values, value, getTagValue) {
  return {
    [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING]: values[
      NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING
    ].filter(i => getTagValue(i) !== value),
    [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING_GROUP]: values[
      NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING_GROUP
    ].filter(i => getTagValue(i) !== value),
  }
}

function excludeAudience(values, value) {
  if (AUDIENCE.includes(value)) {
    return { [value]: false }
  }

  if (NON_REGISTERED_USERS.includes(value)) {
    if (
      isAllUsersValue(
        values[NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_NON_REGISTERED_USERS]
          .value
      )
    ) {
      const valueKey = NON_REGISTERED_USERS.find(i => i !== value)

      return {
        [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_NON_REGISTERED_USERS]:
          NON_REGISTERED_USERS_OPTIONS.find(i => i.value === valueKey),
      }
    } else {
      return {
        [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_NON_REGISTERED_USERS_CHECKBOX]: false,
      }
    }
  }

  if (REGISTERED_USERS.includes(value)) {
    if (
      isAllUsersValue(
        values[NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_REGISTERED_USERS].value
      )
    ) {
      const valueKey = REGISTERED_USERS.find(i => i !== value)

      return {
        [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_REGISTERED_USERS]:
          REGISTERED_USERS_OPTIONS.find(i => i.value === valueKey),
      }
    } else {
      return {
        [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_REGISTERED_USERS_CHECKBOX]: false,
      }
    }
  }
}

export function parseSubmitValues(values) {
  return {
    [ALL_BUILDING_GROUPS_COUNT]: values[ALL_BUILDING_GROUPS_COUNT],
    [ALL_BUILDINGS_COUNT]: values[ALL_BUILDINGS_COUNT],
    new_audience: [
      ...parseAudience(values),
      ...parseRegisteredUsersAudience(values),
      ...parseNonRegisteredUsersAudience(values),
    ],
    ...parseBuildings(values),
    ...parseBuildingGroups(values),
    ...(values[NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_USER_INFO_STATUS]
      .length > 0
      ? {
          [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_USER_INFO_STATUS]:
            values[NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_USER_INFO_STATUS],
        }
      : null),
  }
}

export function parseTagValues(values) {
  return [
    ...toMultiValueList(parseAudience(values)),
    ...(values[NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_RADIO_BUILDINGS] ===
    RecipientAudienceOptionValue.Building
      ? values[NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING]
      : values[NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING_GROUP]),
    ...toMultiValueList(parseRegisteredUsersAudience(values)),
    ...toMultiValueList(parseNonRegisteredUsersAudience(values)),
    ...values[NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_USER_INFO_STATUS],
  ]
}

export function parseChangedValues({
  excludedValue,
  getTagValue,
  valueList,
  values,
}) {
  const requiredBuildingAudience = valueList.filter(i =>
    BUILDING_REQUIRED_AUDIENCE.includes(i.value)
  )

  const nextValues = isBuildingOrBuildingGroupTagValue(
    getTagValue(excludedValue)
  )
    ? excludeBuildingOrBuildingGroup(
        values,
        getTagValue(excludedValue),
        getTagValue
      )
    : excludeAudience(values, getTagValue(excludedValue))

  if (requiredBuildingAudience?.length === 0) {
    return {
      ...values,
      ...nextValues,
      [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING]: EMPTY_LIST,
      [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING_GROUP]: EMPTY_LIST,
    }
  }

  if (
    requiredBuildingAudience?.length > 0 &&
    nextValues?.[NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING_GROUP]
      ?.length === 0 &&
    nextValues?.[NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING]?.length ===
      0
  ) {
    return {
      ...values,
      ...nextValues,
      [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_NON_REGISTERED_USERS_CHECKBOX]: false,
      [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_REGISTERED_USERS_CHECKBOX]: false,
      [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_TV_SCREENS]: false,
    }
  }

  return { ...values, ...nextValues }
}
